// extracted by mini-css-extract-plugin
export var arrows = "_5p-6";
export var decrementer = "_5p-a";
export var disabled = "_5p-4";
export var error = "_5p-1";
export var hiddenText = "_5p-b";
export var incrementer = "_5p-9";
export var input = "_5p-8";
export var inputWrapper = "_5p-0";
export var leadingIcon = "_5p-c";
export var readonly = "_5p-3";
export var regular = "_5p-7";
export var small = "_5p-5";
export var warning = "_5p-2";